/* Block - Card Carousel.
 *
 * Imports the block css.
 * Contains block-specific functionality.
 *
 * @file single
 *
 */
/* eslint-disable-next-line */

/* eslint-disable-next-line */
import styles from './block-card-carousel.scss';
import rsCarousel from '../../js/component/_carousel-team';
import rsCardLink from '../../js/component/_card';

rsCardLink.init('.rs-card-container');

const carousels = Array.from(document.querySelectorAll('body:not(.wp-admin) .rs-card-carousel'));

rsCarousel.init(carousels);
